'use client';

import React from 'react';
import {
  OpenFeature,
  OpenFeatureProvider,
  OpenFeatureTestProvider as OpenFeatureDummyProvider,
  type Provider,
} from '@openfeature/react-sdk';
import { PROVIDER_DOMAIN } from './constants';

export function ClientProvider({
  provider,
  runInDevMode,
  children,
}: {
  provider: Provider | null;
  runInDevMode: boolean;
  children: React.ReactNode;
}) {
  const initRef = React.useRef(false);

  if (runInDevMode) {
    return <OpenFeatureDummyProvider>{children}</OpenFeatureDummyProvider>;
  }

  if (!initRef.current && provider) {
    initRef.current = true;
    OpenFeature.setProvider(PROVIDER_DOMAIN, provider);
  }

  return (
    <OpenFeatureProvider domain={PROVIDER_DOMAIN}>
      {children}
    </OpenFeatureProvider>
  );
}
